export default "__VITE_ASSET__58a62834__"